// =========================================================================
// 🧮 MOTOR CENTRAL DE CLASIFICACIÓN (SUIZO + DESEMPATE SUPREMO)
// =========================================================================
export function calculateStandings(tournament) {
    let stats = (tournament.players || []).map(p => ({ 
        ...p, wins: 0, pf: 0, pa: 0, gamesPlayed: 0, h2h: {},
        tbWins: 0, tbPf: 0, tbPa: 0, tbH2H: {} 
    }));
    let map = stats.reduce((a, p) => ({...a, [p.id]: p}), {});
    
    // 1. Calcular Fase Suiza
    const realMatches = (tournament.phase1Matches || []).filter(m => !m.isKubey && m.status === 'completed');
    realMatches.forEach(m => {
        let p1 = map[m.p1], p2 = map[m.p2];
        if(!p1 || !p2) return;
        let s1 = Number(m.p1Score), s2 = Number(m.p2Score);
        p1.pf += s1; p1.pa += s2; p1.gamesPlayed++;
        p2.pf += s2; p2.pa += s1; p2.gamesPlayed++;
        if (s1 > s2) { p1.wins++; p1.h2h[p2.id] = 1; p2.h2h[p1.id] = -1; }
        else if (s2 > s1) { p2.wins++; p2.h2h[p1.id] = 1; p1.h2h[p2.id] = -1; }
    });

    // Calcular protocolo Kubey
    const kubeyMatches = (tournament.phase1Matches || []).filter(m => m.isKubey);
    kubeyMatches.forEach(m => {
        const player = map[m.p1]; 
        if (player && player.gamesPlayed > 0) {
            const simPF = player.pf / player.gamesPlayed;
            const simPA = player.pa / player.gamesPlayed;
            player.pf += simPF;
            player.pa += simPA;
            if (simPF > simPA) player.wins++;
        }
    });

    // 2. Calcular Fase de Desempate Supremo (si existe)
    if (tournament.tiebreakerMatches) {
        const completedTb = tournament.tiebreakerMatches.filter(m => m.status === 'completed');
        completedTb.forEach(m => {
            let p1 = map[m.p1], p2 = map[m.p2];
            if(!p1 || !p2) return;
            let s1 = Number(m.p1Score), s2 = Number(m.p2Score);
            p1.tbPf += s1; p1.tbPa += s2;
            p2.tbPf += s2; p2.tbPa += s1;
            if (s1 > s2) { p1.tbWins++; p1.tbH2H[p2.id] = 1; p2.tbH2H[p1.id] = -1; }
            else if (s2 > s1) { p2.tbWins++; p2.tbH2H[p1.id] = 1; p1.tbH2H[p2.id] = -1; }
        });
    }
    
    // 3. Ordenar Clasificación Absoluta
    stats.sort((a, b) => {
        // Prioridad 1: Victorias Suizo
        if (Math.round(b.wins * 100) !== Math.round(a.wins * 100)) return b.wins - a.wins;
        // Prioridad 2: Puntos a Favor Suizo
        if (Math.round(b.pf * 100) !== Math.round(a.pf * 100)) return b.pf - a.pf;
        // Prioridad 3: Diferencia de Puntos Suizo
        let difB = b.pf - b.pa; let difA = a.pf - a.pa;
        if (Math.round(difB * 100) !== Math.round(difA * 100)) return difB - difA;
        
        // Prioridad 4: Resultados del Desempate Supremo (si lo hubo)
        if (a.tbWins !== b.tbWins) return b.tbWins - a.tbWins;
        let tbDifB = b.tbPf - b.tbPa; let tbDifA = a.tbPf - a.tbPa;
        if (Math.round(tbDifB * 100) !== Math.round(tbDifA * 100)) return tbDifB - tbDifA;
        if (a.tbH2H[b.id] === 1) return -1;
        if (a.tbH2H[b.id] === -1) return 1;

        // Prioridad 5: Enfrentamiento Directo Suizo (si no hubo Desempate Supremo)
        if (a.h2h[b.id] === 1) return -1;
        if (a.h2h[b.id] === -1) return 1;
        
        return 0;
    });
    return stats;
}